import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'common/components';
import { EOrderDirection, EOrderField } from 'common/const';
import { LegalEntityProvider, SubdivisionProvider, UserProvider } from 'common/context';
import { LIST_LIMIT_0 } from 'common/config';
import { AuthHooks, UserHooks } from 'common/hooks';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { SettingsAccount, SettingsContract, SettingsSidebar, SettingsSubdivision } from 'entities/Settings/components';
import { ESettingsTab } from 'entities/Settings/Settings.enum';
import { getContractList } from 'entities/Contract/Contract.slice';
import { getSubdivisionList } from 'entities/Subdivision/Subdivision.slice';
import { selectCurrentUser } from 'entities/User/User.slice';

export const SettingsPage: FC = () => {
  const dispatch = useAppDispatch();
  // user
  const currentUser = useAppSelector(selectCurrentUser);

  const [fetchLoading, setFetchLoading] = useState<boolean>(true);
  const { tab } = useParams();
  const { isSeller } = AuthHooks.useIsSeller();
  const { isAccountAdmin, isSellerManager } = UserHooks.useCurrentUserRole();

  const currentUserId = currentUser?.id;
  const isAccountSettings = tab === ESettingsTab.Account;

  useEffect(() => {
    const fetch = async () => {
      if (isSeller) {
        await dispatch(
          getContractList({ limit: LIST_LIMIT_0, userId: !isAccountAdmin && isSellerManager ? currentUserId : undefined }),
        );
      } else {
        await dispatch(
          getSubdivisionList({
            orderField: EOrderField.Name,
            orderDirection: EOrderDirection.ASC,
            limit: LIST_LIMIT_0,
          }),
        );
      }

      setFetchLoading(false);
    };

    fetch();
  }, []);

  if (fetchLoading) {
    return (
      <div className="redesign h-full flex align-center justify-center">
        <Spin />
      </div>
    );
  }

  return (
    <UserProvider>
      <LegalEntityProvider>
        <SubdivisionProvider>
          <div className="redesign settings">
            <SettingsSidebar isSeller={isSeller} isAccountAdmin={isAccountAdmin} />

            {isAccountSettings ? (
              <SettingsAccount isSeller={isSeller} />
            ) : isSeller ? (
              <SettingsContract isAccountAdmin={isAccountAdmin} />
            ) : (
              <SettingsSubdivision />
            )}
          </div>
        </SubdivisionProvider>
      </LegalEntityProvider>
    </UserProvider>
  );
};
